(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flexofytol-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fx-faq')) {
    customElements.define('fx-faq', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        // Complément au groupement HTML natif pour les anciens navigateurs.
        this.addEventListener('toggle', (event) => {
          const item = event.target;
          if (
            this.dataset.exclusive !== 'true' ||
            !item.matches('[data-fxq-item]') ||
            !item.open
          ) return;

          this.querySelectorAll('[data-fxq-item]').forEach((other) => {
            if (other !== item && other.open) other.open = false;
          });
        }, { ...options, capture: true });

        // Entrée et Espace sont gérés nativement par <summary>.
        // Les flèches, Home et End facilitent le parcours des questions.
        this.addEventListener('keydown', (event) => {
          if (!event.target.matches('.fxq-question')) return;
          const summaries = Array.from(this.querySelectorAll('.fxq-question'));
          const current = summaries.indexOf(event.target);
          if (current < 0) return;
          let next;
          switch (event.key) {
            case 'ArrowDown': next = (current + 1) % summaries.length; break;
            case 'ArrowUp': next = (current - 1 + summaries.length) % summaries.length; break;
            case 'Home': next = 0; break;
            case 'End': next = summaries.length - 1; break;
            default: return;
          }
          event.preventDefault();
          summaries[next].focus();
        }, options);

        // Dans l’éditeur, afficher immédiatement la réponse sélectionnée.
        this.addEventListener('shopify:block:select', (event) => {
          const blockId = event.detail && event.detail.blockId;
          if (!blockId) return;
          const items = Array.from(this.querySelectorAll('[data-fxq-item]'));
          const selected = items.find((item) => item.dataset.blockId === blockId);
          if (!selected) return;
          if (this.dataset.exclusive === 'true') {
            items.forEach((item) => {
              if (item !== selected) item.open = false;
            });
          }
          selected.open = true;
        }, options);
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexofytol-formulation"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fx-formulation')) {
  customElements.define('fx-formulation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.initFrame) return;
      // Laisser le navigateur terminer l'insertion du contenu de la section.
      this.initFrame = requestAnimationFrame(() => {
        this.initFrame = null;
        if (this.isConnected) this.initialize();
      });
    }

    initialize() {
      if (this.controller) return;
      this.tabs = Array.from(this.querySelectorAll('[data-fxf-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-fxf-panel]'));
      if (!this.tabs.length || this.tabs.length !== this.panels.length) return;

      this.controller = new AbortController();
      this.index = 0;
      this.gesture = null;
      this.motionTimer = null;
      this.suppressClickUntil = 0;
      this.duration = Math.min(800, Math.max(200, Number(this.dataset.slideDuration) || 450));
      this.swipeEnabled = this.dataset.swipeEnabled !== 'false' && this.panels.length > 1;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.status = this.querySelector('[data-fxf-status]');
      this.classList.toggle('is-swipe-ready', this.swipeEnabled);
      const options = { signal: this.controller.signal };

      this.addEventListener('click', (event) => {
        if (performance.now() < this.suppressClickUntil) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        const tab = event.target.closest('[data-fxf-tab]');
        if (tab && this.contains(tab)) this.goTo(this.tabs.indexOf(tab));
      }, options);

      this.addEventListener('keydown', (event) => {
        const current = this.tabs.indexOf(event.target);
        if (current < 0) return;
        let next;
        let direction;
        switch (event.key) {
          case 'ArrowRight':
            next = (current + 1) % this.tabs.length;
            direction = 1;
            break;
          case 'ArrowLeft':
            next = (current - 1 + this.tabs.length) % this.tabs.length;
            direction = -1;
            break;
          case 'Home': next = 0; break;
          case 'End': next = this.tabs.length - 1; break;
          default: return;
        }
        event.preventDefault();
        this.goTo(next, { direction, focus: true });
      }, options);

      this.addEventListener('pointerdown', (event) => this.pointerDown(event), options);
      window.addEventListener('pointermove', (event) => this.pointerMove(event), {
        ...options, passive: false
      });
      window.addEventListener('pointerup', (event) => this.pointerEnd(event), options);
      window.addEventListener('pointercancel', (event) => this.pointerEnd(event, true), options);
      this.addEventListener('lostpointercapture', (event) => {
        // Ignorer la capture tactile transférée d'un enfant vers la section.
        if (event.target === this) this.pointerEnd(event, true);
      }, options);
      this.addEventListener('dragstart', (event) => {
        if (this.swipeEnabled) event.preventDefault();
      }, options);
      window.addEventListener('blur', () => this.resetInteraction(), options);

      // Afficher immédiatement le bloc sélectionné dans l'éditeur Shopify.
      this.addEventListener('shopify:block:select', (event) => {
        const next = this.panels.findIndex(
          (panel) => panel.dataset.blockId === event.detail?.blockId
        );
        if (next >= 0) this.goTo(next, { instant: true });
      }, options);

      this.select(0);
      this.finishMotion();

      // Charger les autres photos quand la section approche de l'écran.
      if ('IntersectionObserver' in window) {
        this.imageObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.panels.forEach((_, index) => this.loadImage(index));
            this.imageObserver.disconnect();
          }
        }, { rootMargin: '350px' });
        this.imageObserver.observe(this);
      }
      if ('ResizeObserver' in window) {
        this.lastWidth = this.clientWidth;
        this.resizeObserver = new ResizeObserver(() => {
          if (Math.abs(this.clientWidth - this.lastWidth) > 1) {
            this.lastWidth = this.clientWidth;
            this.resetInteraction();
          }
        });
        this.resizeObserver.observe(this);
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.initFrame = null;
      this.resetInteraction();
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.imageObserver?.disconnect();
      this.controller = null;
    }

    loadImage(index) {
      const image = this.panels[index]?.querySelector('img');
      if (image) image.loading = 'eager';
    }

    select(index, announce = false) {
      // Éviter de laisser le focus dans un panneau qui devient inactif.
      const focusedPanel = this.panels.findIndex(
        (panel) => panel.contains(document.activeElement)
      );
      if (focusedPanel >= 0 && focusedPanel !== index) {
        this.tabs[index].focus({ preventScroll: true });
      }
      this.index = index;
      this.tabs.forEach((tab, current) => {
        const selected = current === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach((panel, current) => {
        const selected = current === index;
        panel.classList.toggle('is-active', selected);
        panel.setAttribute('aria-hidden', String(!selected));
        panel.inert = !selected;
        panel.tabIndex = selected ? 0 : -1;
      });
      this.loadImage(index);
      if (announce && this.status) {
        const title = this.panels[index].querySelector('.fxf-heading')?.textContent.trim() || '';
        this.status.textContent = `Étape ${index + 1} sur ${this.panels.length} : ${title}`;
      }
    }

    offset(index, percent) {
      this.panels[index]?.style.setProperty('--fxf-slide-x', `${percent}%`);
    }

    finishMotion() {
      window.clearTimeout(this.motionTimer);
      this.motionTimer = null;
      this.classList.remove('is-animating', 'is-dragging');
      this.panels?.forEach((panel) => {
        panel.classList.remove('is-moving');
        panel.style.removeProperty('--fxf-slide-x');
      });
    }

    releaseGesture() {
      const gesture = this.gesture;
      this.gesture = null;
      if (gesture && this.hasPointerCapture(gesture.id)) {
        this.releasePointerCapture(gesture.id);
      }
      return gesture;
    }

    resetInteraction() {
      this.releaseGesture();
      this.finishMotion();
    }

    // Animer à partir des positions courantes, puis nettoyer les styles.
    settle(base, neighbor, direction, target, announce = false) {
      this.panels[base].classList.add('is-moving');
      if (neighbor >= 0) this.panels[neighbor].classList.add('is-moving');
      this.select(target, announce);
      if (this.reducedMotion.matches) {
        this.finishMotion();
        return;
      }
      // Lecture de mise en page : conserver le point de départ de la transition.
      this.panels[base].querySelector('.fxf-copy-content').getBoundingClientRect();
      this.classList.remove('is-dragging');
      this.classList.add('is-animating');
      this.offset(base, target === base ? 0 : -direction * 100);
      if (neighbor >= 0) {
        this.offset(neighbor, target === base ? direction * 100 : 0);
      }
      this.motionTimer = window.setTimeout(() => this.finishMotion(), this.duration + 50);
    }

    goTo(index, { direction, focus = false, instant = false } = {}) {
      if (index < 0 || index >= this.panels.length) return;
      this.resetInteraction();
      const base = this.index;
      if (index === base || instant || this.reducedMotion.matches) {
        this.select(index);
      } else {
        direction = direction || (index > base ? 1 : -1);
        this.loadImage(index);
        this.offset(base, 0);
        this.offset(index, direction * 100);
        this.panels[index].classList.add('is-moving');
        this.settle(base, index, direction, index);
      }
      if (focus) this.tabs[index].focus({ preventScroll: true });
    }

    pointerDown(event) {
      if (!event.isPrimary) {
        // Deux doigts : libérer le geste pour le zoom natif.
        if (this.gesture) this.resetInteraction();
        return;
      }
      if (!this.swipeEnabled || this.motionTimer || event.button !== 0) return;
      if (window.Shopify?.inspectMode) return;
      if (event.target.closest('a, button, input, select, textarea, [contenteditable="true"]')) return;
      const panel = this.panels[this.index];
      const surface = event.target.closest('.fxf-media') || panel.querySelector('.fxf-copy-clip');
      this.gesture = {
        id: event.pointerId,
        base: this.index,
        x: event.clientX,
        y: event.clientY,
        width: Math.max(1, surface?.clientWidth || this.clientWidth),
        dx: 0,
        lastX: event.clientX,
        lastTime: event.timeStamp,
        velocity: 0,
        locked: false,
        neighbor: -1,
        direction: 1
      };
    }

    pointerMove(event) {
      const gesture = this.gesture;
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (!gesture.locked) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          this.releaseGesture();
          return; // Le défilement vertical de la page reste natif.
        }
        if (Math.abs(dx) < Math.abs(dy) * 1.15) return;
        gesture.locked = true;
        this.classList.add('is-dragging');
        this.setPointerCapture(event.pointerId);
        this.loadImage(gesture.base - 1);
        this.loadImage(gesture.base + 1);
      }
      if (event.cancelable) event.preventDefault();
      gesture.velocity = (event.clientX - gesture.lastX) / Math.max(1, event.timeStamp - gesture.lastTime);
      gesture.lastX = event.clientX;
      gesture.lastTime = event.timeStamp;
      gesture.dx = dx;
      gesture.direction = dx <= 0 ? 1 : -1;
      const candidate = gesture.base + gesture.direction;
      gesture.neighbor = candidate >= 0 && candidate < this.panels.length ? candidate : -1;
      let progress = Math.max(-1, Math.min(1, dx / gesture.width));
      if (gesture.neighbor < 0) progress *= 0.18; // Résistance en début et fin.
      this.panels.forEach((panel, index) => {
        panel.classList.toggle('is-moving', index === gesture.base || index === gesture.neighbor);
      });
      this.offset(gesture.base, progress * 100);
      if (gesture.neighbor >= 0) {
        this.offset(gesture.neighbor, (gesture.direction + progress) * 100);
      }
    }

    pointerEnd(event, cancelled = false) {
      if (!this.gesture || this.gesture.id !== event.pointerId) return;
      const gesture = this.releaseGesture();
      if (!gesture.locked) return;
      this.suppressClickUntil = performance.now() + 300;
      const distanceEnough = Math.abs(gesture.dx) >= Math.min(90, gesture.width * 0.18);
      const flick = event.timeStamp - gesture.lastTime < 100 &&
        Math.abs(gesture.dx) > 20 && Math.abs(gesture.velocity) > 0.5 &&
        Math.sign(gesture.velocity) === Math.sign(gesture.dx);
      const advance = !cancelled && gesture.neighbor >= 0 && (distanceEnough || flick);
      const target = advance ? gesture.neighbor : gesture.base;
      this.settle(gesture.base, gesture.neighbor, gesture.direction, target, advance);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
